import { useSelector } from 'react-redux';

import { TIME_RANGE_35_DAYS, TIME_RANGE_3_DAYS, TIME_RANGE_WEEK } from '@/services/constants';
import { ApplicationState } from '@/store';
import { canSeeExtendedLogs } from '../../../assets/EventFilter/helperFunctions';

export const useTimeRange = (): number => {
    const {
        account: { GeneralInfo },
    } = useSelector((state: ApplicationState) => state);

    const limitedLogDays = GeneralInfo?.KeepLogsForDays === TIME_RANGE_3_DAYS ? TIME_RANGE_3_DAYS : TIME_RANGE_WEEK;
    return canSeeExtendedLogs(GeneralInfo?.AccountAccessLevel) ? TIME_RANGE_35_DAYS : limitedLogDays;
};
